<div (click)="dimiss()" class="container">
  <div class="kitchen" *ngIf="type == 'kitchen'">
    <p>این قسمت از برنامه به مدیریت آشپزخانه شما کمک می‌کند:</p>
    <p>۱- پیشنهاد دستور پخت بر اساس مواد موجود</p>
    <p>۲- کنترل موجودی مواد مورد نیاز برنامه غذایی</p>
    <p>۳- یادآوری تاریخ انقضا</p>
  </div>
  <div class="kitchen" *ngIf="type == 'shoppingList'">
    <p>
      این قسمت به شما در مدیریت خرید مواد مورد نیاز برنامه غذایی کمک می‌کند:
    </p>

    <p>۱- دسته‌بندی مواد انتخابی</p>
    <p>۲- اشتراک‌گذاری لیست</p>
  </div>
  <div class="kitchen" *ngIf="type == 'members'">
    <p>
      با اضافه کردن افراد به خانه، امکانات زیر با آنها به اشتراک گذاشته‌ می‌شود:
    </p>

    <p>۱- لیست خرید</p>
    <p>۲- آشپزخانه</p>
  </div>
  <div class="button-holder" *ngIf="type == 'kitchen' || type == 'members'">
    <div class="add-button" *ngIf="type == 'kitchen' || type == 'members'">
      <img src="assets/cookingbook/forward.svg" alt="" />
      <p>متوجه شدم</p>
    </div>
  </div>
  <div class="button" *ngIf="type == 'shoppingList'">
    <img src="assets/cookingbook/forward.svg" alt="" />
    متوجه شدم
  </div>
</div>
